import React from 'react';
import { useTranslation } from 'react-i18next';

import './DecisionTimeHeaderContent.scss';

const DecisionTimeHeaderContent = () => {
  const { t } = useTranslation();

  return <div className="decision-time-header-content">{t('have-the-option-of-two-players-to-choose-from-on-friday')}</div>;
};

export default DecisionTimeHeaderContent;
